/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import React from 'react';
import { Link as MUILink, LinkProps as MUILinkProps } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './Link.styles';

interface LinkProps extends MUILinkProps {
  disabled?: boolean;
  testId: string;
}

const Link = <C extends React.ElementType = 'a'>(
  props: LinkProps &
    React.ComponentProps<C> & {
      component?: C;
    }
) => {
  const { children, disabled, className, testId, ...rest } = props;
  const classes = useStyles();
  return (
    <MUILink
      data-testid={`${testId}-link`}
      data-cyid={`${testId}-link`}
      {...rest}
      className={clsx(className, {
        [classes.link]: true,
        [classes.linkDisabled]: disabled,
      })}
    >
      {children}
    </MUILink>
  );
};

export default Link;
